var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefunded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#refunded)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475569",
    fillRule: "evenodd",
    d: "M5.813 4.5a.875.875 0 0 0-.875.875V11.5l1.53-.875L8 11.5l1.531-.875 1.531.875V5.375a.875.875 0 0 0-.874-.875H5.811Zm2.059 1.622a.438.438 0 0 0-.619-.619L5.941 6.816a.438.438 0 0 0 0 .618l1.312 1.313a.438.438 0 0 0 .619-.619l-.566-.566H8c.725 0 1.313.588 1.313 1.313v.438a.438.438 0 0 0 .874 0v-.438c0-1.208-.979-2.188-2.187-2.188h-.694l.566-.565Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "refunded"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunded);
export default __webpack_public_path__ + "static/media/refunded.ce3567ac85d186a1afb7000d470e2238.svg";
export { ForwardRef as ReactComponent };